module.exports = () => {
  document
    .getElementById('ReadingView')
    .scroll({ top: 0, left: 0 })
}